import { stats } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="bg-background-50 border-b border-background-200/70">
      <div className="w-full px-4 md:px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2 text-primary-500">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-foreground-600 mt-1">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}